<template>
  <div class="table">
    <div class="row">
      <div class="col col1 time">
        {{ getFormattedTime(show.time_start) }}
      </div>
      <div class="col col1">
        <div class="img" v-bind:style="imgStyles"></div>
      </div>
      <div class="col col2 cursor-pointer" v-on:click="detail()">
        <div class="title">
          {{ show.artist.title }}
          <hr />
          <span class="stage">STAGE: {{ show.venue.title }}</span>
        </div>
        <div class="action">
          <font-awesome-icon
            v-if="toggleDetail === false"
            :icon="['fas', 'angle-down']"
            class="cursor-pointer"
          />
          <font-awesome-icon
            v-if="toggleDetail === true"
            :icon="['fas', 'angle-up']"
            class="cursor-pointer"
          />
        </div>
      </div>
    </div>
    <div class="caption" v-if="toggleDetail === true">
      <artistDetail :artist="show.artist" :initLoad="toggleDetail" />
    </div>
  </div>
</template>

<script>
import artistDetail from "./artistDetail.vue";
import { formatTime } from "../helpers";
export default {
  name: "showList",
  data: function () {
    return {
      flipped: false,
      toggleDetail: false,
      imgStyles: {},
    };
  },
  components: {
    artistDetail,
  },
  props: {
    show: Object,
  },
  mounted() {
    // do lazy loading of images
    if ("IntersectionObserver" in window) {
      let options = {
        root: document.querySelector("#scrollArea"),
        rootMargin: "150px",
        threshold: 0,
      };
      let observer = new IntersectionObserver(this.listObserver, options);
      observer.observe(this.$el);
    } else {
      // cant do lazy loading images
      this.imgStyles = {
        backgroundImage: `url(${this.show.artist.photo}?height=320)`,
      };
      this.imgLoaded = true;
    }
  },
  methods: {
    getFormattedTime: function (timeStr) {
      return formatTime(timeStr);
    },
    showArtistDetail: async function () {
      if (!this.artist.detail) {
        await this.show.artist.getDetail();
      }
    },
    detail() {
      this.toggleDetail = !this.toggleDetail;
    },
    listObserver(entries) {
      // lazy load the image
      if (entries[0].isIntersecting && !this.imgLoaded) {
        this.imgStyles = {
          backgroundImage: `url(${this.show.artist.photo}?height=320)`,
        };
        this.imgLoaded = true;
      }
    },
  },
};
</script>
